module.exports = __webpack_public_path__ + "img/kr.cc2a1dda.svg";